import { RailsItemDetail } from '~/typings/services/rails/item';

export default function findFirstDetailId(
  details: RailsItemDetail[],
  slug: string,
) {
  return details?.find(d => d.slug === slug)?.values?.[0]?.id;
}
